import React, { useContext, useCallback } from 'react';
import {
  components,
  GroupTypeBase,
  MenuListComponentProps,
  OptionTypeBase,
  Props as SelectProps,
  OptionProps,
} from 'react-select';

import Avatar from 'components/Avatar';
import {
  Container,
  SelectComponent,
  customStyles,
  menuHeaderStyle,
  OptionContent,
  OptionThree,
} from './styles';
import { ThemeContext } from 'styled-components';

interface IMenuListProps
  extends MenuListComponentProps<
    OptionTypeBase,
    boolean,
    GroupTypeBase<OptionTypeBase>
  > {
  isLoading: boolean;
}

interface IOptionProps
  extends OptionProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>> {}

interface Props
  extends Omit<SelectProps<OptionTypeBase>, 'theme' | 'isLoading'> {
  name?: string;
  placeholder?: string;
  searchable?: boolean;
  disabled?: boolean;
  errorField?: string;
  type: 'avatar' | 'default' | 'threeOptions';
}

const AsyncSelect: React.FC<Props> = ({
  searchable,
  type = 'default',
  disabled,
  errorField,
  ...rest
}: Props) => {
  // const selectAsyncRef = useRef(null);
  const themeContext = useContext(ThemeContext);

  const MenuList = useCallback((props: IMenuListProps) => {
    return (
      <components.MenuList {...props}>
        {!props.isLoading && (
          <div style={menuHeaderStyle}>Digite pelo menos 3 caracteres</div>
        )}
        {props.children}
      </components.MenuList>
    );
  }, []);

  const OptionAvatar = useCallback((props: IOptionProps) => {
    return (
      <OptionContent>
        <Avatar
          size="36"
          name={props.data.label}
          src={props.data.avatar_url}
          round
          alt={props.data.label}
        />

        <components.Option {...props} />
      </OptionContent>
    );
  }, []);

  const optionDefault = useCallback((props: IOptionProps) => {
    return <components.Option {...props} />;
    // return <components.Option {...props}>{children}</components.Option>;
  }, []);

  const OptionThreeLabel = useCallback(({ theme, ...rest }: IOptionProps) => {
    const { innerProps, innerRef } = rest;
    return (
      <OptionThree ref={innerRef} {...innerProps}>
        <p>{rest.data.label}</p>
        {rest.data.sublabel ? <span>({rest.data.sublabel})</span> : ''}
      </OptionThree>
    );
  }, []);

  const customOption = {
    default: optionDefault,
    threeOptions: OptionThreeLabel,
    avatar: OptionAvatar,
  };

  return (
    <Container error={errorField}>
      {themeContext && (
        <SelectComponent
          // ref={selectAsyncRef}
          styles={customStyles(themeContext)}
          isSearchable={searchable}
          isDisabled={disabled}
          isMulti={rest.isMulti}
          classNamePrefix="react-select"
          components={{ MenuList, Option: customOption[type] }}
          {...rest}
        />
      )}
      {/* {!!errorField && <ErrorMessage>{error || errorField}</ErrorMessage>} */}
    </Container>
  );
};

export default AsyncSelect;
